/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {InfoIcon} from '../../icons/InfoIcon';
import {dlsAlt, dlsColor, dlsTypography} from '../../theme/theme';
import Tooltip from './Tooltip';

const useStyles = makeStyles(() => ({
  info : {
    height : '24px'
  }
}));

export const useSpaciousTooltipStyles = makeStyles(() => ({
  tooltip : {
    ...dlsTypography('caption'),
    backgroundColor : dlsAlt('colors', 'tooltipBackground'),
    color           : dlsColor('white'),
    minWidth        : 100,
    padding         : '12px',
    fontSize        : '14px !important',
    fontWeight      : 400,
    lineHeight      : '20px !important',
    textAlign       : 'center'
  },
  arrow : {
    color : dlsAlt('colors', 'tooltipBackground')
  }
}));

interface InfoTooltipProps {
  message?: string;
  color?: string;
  size?: number;
  spacious?: boolean;
}

/**
 * This component will render an Info Icon with a tooltip on hover
 * with the given message.
 *
 * ```typescript
 *  <InfoTooltip message={message} />
 * ```
 */
export const InfoTooltip = ({
  color,
  message,
  size,
  spacious = false
}: InfoTooltipProps) => {
  const classes         = useStyles();
  const spaciousClasses = useSpaciousTooltipStyles();
  return (
    <Tooltip arrow
      externalClasses={spacious ? spaciousClasses : undefined}
      title={message}>
      <span className={classes.info}><InfoIcon size={size} color={color} /></span>
    </Tooltip>
  );
};

export default React.memo(InfoTooltip);
